export default {
	project_name: 'Academia Pintuco',
	company_agency: 'Entreprise / Magasin',
	no_company_agency_found: "Entreprise / Magasin no encontrada",
	add_new_company: "Ajouter une nouvelle entreprise",
}
